import {
  EpkModuleApiService,
  getFilteredData,
} from '~packages/epk-front-shared/api-client';
import type { Filters, Params } from '~packages/epk-front-shared/api-client';
import { Mode } from '~packages/json-api/client';

import getConstants from '@/shared/constants';

const { isModeDevelopment } = getConstants();

const constructorParams = {
  className: 'AggReportsApiService',
  mode: isModeDevelopment ? Mode.Production : Mode.Production,
  // needInit: isModeDevelopment,
};

export interface GetDocTitleResponse {
  data: {
    date: string;
    name: string;
    all: number;
    broken: number;
    order?: number;
  }[];
}
export default class AggReportsApiService extends EpkModuleApiService {
  constructor() {
    super(constructorParams);
  }

  async getDoc(id: bigint | string) {
    return await this._sendRequest(
      this.pathFetch + 'doc/' + id,
      null,
      { method: this.requestMethodFetch },
      { method: 'fetch' }
    );
  }

  async getFilteredData(filters: Filters, params: Params) {
    return await getFilteredData(this, filters, params);
  }

  async getDocTitle(id: string) {
    const pathFetch = this.pathFetch;
    this.pathFetch = '/data/title/';
    const _getDocTitle = async (id: string) => {
      const data = (await this.fetch(id)) as { response: { data: Array<any> } };

      const valuesNames = ['all', 'broken'];
      const itemName = 'fo_eo';

      const pattern = /[0-9]{4}-[0-9]{2}-[0-9]{2}/gi;

      const response = data?.response?.data?.map((item, index) => {
        const area_unit = item[itemName];

        const values = Object.entries(item).reduce<any>((res, [key, value]) => {
          if (key.match(pattern)) {
            const dateName = key.match(pattern)?.[0] || '';
            const current = res[dateName]?.cols || [];
            const _keyName =
              valuesNames.find(item => key.includes(item)) || 'noName';

            return {
              ...res,
              [valueKey]: current + value,
            };
          }

          return res;
        }, {});

        return Object.entries(values).map(([date, values]: [string, any]) => ({
          ...values.cols.reduce(
            (res: any, col: any) => ({ ...res, [col.key]: col.value }),
            {}
          ),
          date: date,
          area_unit,
          order: index + 1,
        }));
      });

      const flatResponse = response?.flat() || [];

      const common = {
        area_unit: 'ИТОГО',
        ...valuesNames.reduce(
          (result, key) => ({
            ...result,
            [key]: Object.values(flatResponse).reduce(
              (res: number, value: any) => res + value[key],
              0
            ),
          }),
          {}
        ),
      };

      return { data: [...flatResponse, common] } as GetDocTitleResponse;
    };
    const response = await _getDocTitle(id);
    this.pathFetch = pathFetch;
    return response;
  }

  async getRefreshInfo({
    point_code,
    tables,
  }: {
    point_code: string;
    tables?: object;
  }) {
    return await super.update({ tables }, `${point_code}/refresh`);
  }

  async getEconomicRegions(params) {
    return await this._sendRequest(
      this.pathFetchAll + 'dict-economic-regions',
      { ...params, size: params?.size ?? 1e5 },
      { method: this.requestMethodFetchAll },
      { method: 'fetchAll' }
    );
  }

  async getFederalRegions(params) {
    return await this._sendRequest(
      this.pathFetchAll + 'dict-federal-regions',
      { ...params, size: params?.size ?? 1e5 },
      { method: this.requestMethodFetchAll },
      { method: 'fetchAll' }
    );
  }

  async getAggReport(reportName: string, guid: string, params) {
    return await this._sendRequest(
      this.pathFetch + `data/${reportName}/${guid}`,
      params,
      { method: this.requestMethodFetch },
      { dataOptions: { guid }, method: 'fetch' }
    );
  }

  async addAggRPC(data: unknown) {
    return await this._sendRequest(
      this.pathAdd,
      undefined,
      { body: this.jsonStringify(data), method: this.requestMethodAdd },
      { method: 'addAggRPC', options: { headers: { 'rpc-execute': true } } }
    );
  }

  async getRefreshInfoPRC(point_code: string) {
    return await this._sendRequest(
      `/${point_code}/refresh`,
      undefined,
      { method: this.requestMethodUpdate },
      {
        method: 'getRefreshInfoPRC',
        options: { headers: { 'rpc-execute': true } },
      }
    );
  }
}
